import React, { FC } from "react";
import cn from "classnames";

const ButtonSizes = {
  small: "w-8 h-8 p-2",
  medium: "w-11 h-11 p-3",
  large: "w-14 h-14 p-4",
};

type IconLineType = "stroke" | "fill";

type Props = {
  Icon: FC<{ className?: string }>;
  size?: keyof typeof ButtonSizes;
  selected?: boolean;
  iconLineType?: IconLineType;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const getIconColor = (iconLineType: IconLineType, selected?: boolean) => {
  if (iconLineType === "fill") return selected ? "fill-white" : "fill-gray-600";
  if (iconLineType === "stroke")
    return selected ? "text-white" : "text-gray-600";
};

/**
 * Some SVGs are drawn by stroke property and some by fill. Therefore we have to distinguish them by a flag.
 * If not specified, we assume stroke is used as it is the case for most SVGs.
 */

const Round: FC<Props> = ({
  Icon,
  size = "medium",
  selected,
  iconLineType = "stroke",
  onClick,
}) => {
  return (
    <button
      className={cn(
        "rounded-full",
        ButtonSizes[size],
        selected ? "bg-vg-orange cursor-default" : "bg-vg-gray"
      )}
      onClick={onClick}
    >
      <Icon
        className={cn("w-full h-full", getIconColor(iconLineType, selected))}
      />
    </button>
  );
};

export default Round;
